import {
  LOAD_DRAFT,
  LOAD_DRAFT_EMPTY,
  LOAD_DRAFT_SUCCESS,
  LOAD_DRAFT_ERROR,
  REPLACE_DRAFT_STATE,
  SAVE_DRAFT,
  SAVE_DRAFT_SUCCESS,
  SAVE_DRAFT_ERROR,
  DELETE_DRAFT,
  DELETE_DRAFT_SUCCESS,
  DELETE_DRAFT_ERROR
} from '../constants';

export const loadDraft = () => ({
  type: LOAD_DRAFT
});

export const loadDraftEmpty = () => ({
  type: LOAD_DRAFT_EMPTY
});

export const loadDraftSuccess = payload => ({
  type: LOAD_DRAFT_SUCCESS,
  payload
});

export const loadDraftError = () => ({
  type: LOAD_DRAFT_ERROR
});

export const replaceDraftState = payload => ({
  type: REPLACE_DRAFT_STATE,
  payload
});

export const saveDraft = () => ({
  type: SAVE_DRAFT
});

export const saveDraftSuccess = payload => ({
  type: SAVE_DRAFT_SUCCESS,
  payload
});

export const saveDraftError = () => ({
  type: SAVE_DRAFT_ERROR
});

export const deleteDraft = () => ({
  type: DELETE_DRAFT
});

export const deleteDraftSuccess = () => ({
  type: DELETE_DRAFT_SUCCESS
});

export const deleteDraftError = () => ({
  type: DELETE_DRAFT_ERROR
});
